/**
 * Thai names and descriptions of game content: heroes, monsters, skills,
 * personalities, tiers, items and quests (presets.ts and rules.json).
 * Display code translates them with t(def.name), t(def.blurb), …
 */
export const CONTENT: Record<string, string> = {
  // Hero classes
  'Pencil Knight': 'อัศวินดินสอ',
  'Red scarf, steel sword, notebook shield. Snips through armor with Scissors.': 'ผ้าพันคอแดง ดาบเหล็ก โล่สมุด ออกกรรไกรชนะแล้วตัดทะลุเกราะ',
  'Crayon Mage': 'จอมเวทสีเทียน',
  'Draws spells in wax. Rock wins hit extra hard.': 'วาดเวทมนตร์ด้วยสีเทียน ออกค้อนชนะแล้วตีแรงเป็นพิเศษ',
  'Eraser Ninja': 'นินจายางลบ',
  'Rubs out attacks before they land. Lucky and slippery.': 'ลบการโจมตีทิ้งก่อนโดน โชคดีและหลบเก่ง',
  'Ruler Guard': 'ผู้พิทักษ์ไม้บรรทัด',
  'Thirty centimetres of pure defence. Paper shields the blow.': 'ป้องกันล้วน ๆ ยาวสามสิบเซนติเมตร ออกกระดาษแล้วกันดาเมจ',
  'Glue Alchemist': 'นักปรุงยากาว',
  'Mixes glue potions in a test tube. Combos just get stuck.': 'ผสมยากาวในหลอดทดลอง คอมโบของศัตรูติดหนึบไปหมด',
  'Highlighter Scout': 'หน่วยสอดแนมปากกาเน้นข้อความ',
  'Marks every weak spot in neon. Each hit recharges the ink.': 'ขีดจุดอ่อนทุกจุดด้วยสีนีออน ตีโดนแต่ละทีหมึกก็เต็มขึ้น',

  // Preset monsters
  'Gum Blob': 'ก้อนหมากฝรั่ง',
  'Found under desk #4. Sticky and stubborn.': 'เจอใต้โต๊ะเบอร์ 4 เหนียวและดื้อ',
  'Homework Ghost': 'ผีการบ้าน',
  'Haunts anyone who forgot page 37.': 'หลอกหลอนทุกคนที่ลืมทำหน้า 37',
  'Spitball Spider': 'แมงมุมกระดาษเปียก',
  'Eight legs, five eyes, zero manners.': 'แปดขา ห้าตา มารยาทศูนย์',
  'Eraser Golem': 'โกเลมยางลบ',
  'A green eraser beast with a pink cap. Rubs out whole chapters.': 'สัตว์ประหลาดยางลบสีเขียวสวมหมวกชมพู ลบทีละทั้งบท',
  'Ink Octopus': 'ปลาหมึกน้ำหมึก',
  "Leaks from the teacher's fountain pen.": 'ไหลออกมาจากปากกาหมึกซึมของคุณครู',
  'Pencil Dragon': 'มังกรดินสอ',
  'Drawn on the last page. Breathes crayon fire.': 'วาดไว้หน้าสุดท้าย พ่นไฟสีเทียน',
  'Stapler Crab': 'ปูแม็กเย็บกระดาษ',
  'Snaps shut on anything. Hitting it hurts your knuckles.': 'งับทุกอย่างที่ขวางหน้า ต่อยมันทีเจ็บมือเอง',
  'Glue Monarch': 'ราชันย์กาว',
  'Rules the art cupboard. Everything near it gets stuck.': 'ปกครองตู้อุปกรณ์ศิลปะ อะไรอยู่ใกล้ก็ติดหนึบหมด',
  'Highlighter Wyvern': 'ไวเวิร์นปากกาเน้นข้อความ',
  'Glows neon green. Drinks the ink of every hit.': 'เรืองแสงสีเขียวนีออน ดูดหมึกจากทุกการโจมตี',
  "Principal's Shadow": 'เงาครูใหญ่',
  'The final boss. Angrier with every scribble you land.': 'บอสใหญ่ตัวสุดท้าย ยิ่งโดนขีดเขียนยิ่งโกรธ',

  // Skills (rules.json)
  'No Skill': 'ไม่มีสกิล',
  'Just a plain doodle. No tricks.': 'ภาพวาดธรรมดา ไม่มีลูกเล่น',
  'Crayon Smash': 'ทุบสีเทียน',
  'Winning with Rock deals +50% damage.': 'ออกค้อนชนะ ดาเมจ +50%',
  'Sharp Edge': 'คมกริบ',
  "Winning with Scissors ignores the defender's DEF.": 'ออกกรรไกรชนะ ไม่สนค่าป้องกัน (DEF) ของฝ่ายรับ',
  'Paper Shield': 'โล่กระดาษ',
  'Losing with Paper halves the damage you take.': 'ออกกระดาษแพ้ รับดาเมจแค่ครึ่งเดียว',
  'Eraser Mend': 'ยางลบซ่อมแซม',
  'On a real tie, heal 10% of max HP.': 'เสมอกันจริง ๆ ฟื้น HP 10% ของ HP สูงสุด',
  'Doodle Dodge': 'หลบแบบภาพวาด',
  '15% chance to dodge incoming damage.': 'มีโอกาส 15% หลบดาเมจที่เข้ามา',
  'Ink Combo': 'คอมโบน้ำหมึก',
  'Combo bonus is doubled (+20% per streak, up to +100%).': 'โบนัสคอมโบเพิ่มเป็นสองเท่า (+20% ต่อการชนะติดกัน สูงสุด +100%)',
  'Lucky Star': 'ดาวนำโชค',
  'Critical hits deal +100% instead of +50%.': 'คริติคอลแรง +100% แทนที่จะเป็น +50%',
  'Highlighter Drain': 'ปากกาดูดพลัง',
  'Winning a round heals you for 25% of the damage dealt.': 'ชนะรอบไหน ฟื้น HP 25% ของดาเมจที่ทำได้',
  'Sharpener Spikes': 'หนามกบเหลาดินสอ',
  'Taking damage hurts the attacker for 25% of it (never knocks them out).': 'โดนโจมตีแล้วสะท้อนดาเมจ 25% กลับใส่ผู้โจมตี (แต่ไม่ทำให้น็อก)',
  'Glue Guard': 'เกราะกาว',
  'Opponents get no combo bonus against you.': 'ศัตรูไม่ได้โบนัสคอมโบเมื่อตีคุณ',
  'Marker Rage': 'ปากกาเมจิกเดือด',
  'Below half HP, your wins deal +50% damage.': 'เมื่อ HP ต่ำกว่าครึ่ง ชนะแล้วดาเมจ +50%',

  // Personalities (rules.json)
  Chaotic: 'วุ่นวาย',
  'Picks completely at random. Pure chaos.': 'สุ่มออกล้วน ๆ วุ่นวายสุด ๆ',
  Stubborn: 'ดื้อรั้น',
  'Loves Rock. Really loves Rock.': 'ชอบออกค้อน ชอบมาก ๆ',
  Shy: 'ขี้อาย',
  'Hides behind Paper most of the time.': 'ชอบหลบหลังกระดาษเกือบตลอดเวลา',
  Sharp: 'เฉียบคม',
  'Snip snip! Prefers Scissors.': 'ฉึบ ๆ! ชอบออกกรรไกร',
  Copycat: 'ขี้เลียนแบบ',
  'Often copies your previous move.': 'มักออกเหมือนที่คุณออกตาที่แล้ว',
  Tricky: 'เจ้าเล่ห์',
  'Often plays what would have beaten your last move.': 'มักออกสิ่งที่ชนะท่าล่าสุดของคุณ',

  // Tiers
  Doodle: 'ขีดเขียน',
  Sketch: 'ภาพร่าง',
  Masterpiece: 'ผลงานชิ้นเอก',

  // Items
  'Pencil Sword': 'ดาบดินสอ',
  'HB lead. Very pointy.': 'ไส้ HB แหลมมาก',
  'Golden Crayon': 'สีเทียนทองคำ',
  'Only for the best drawers.': 'สำหรับคนวาดเก่งที่สุดเท่านั้น',
  'Compass Spear': 'หอกวงเวียน',
  'Draws perfect circles. Ouch.': 'วาดวงกลมได้เป๊ะ โอ๊ย',
  'Cardboard Shield': 'โล่กระดาษลัง',
  'Cut from a cereal box.': 'ตัดจากกล่องซีเรียล',
  'Eraser Armor': 'เกราะยางลบ',
  'Squishy but reliable.': 'นุ่มนิ่มแต่ไว้ใจได้',
  'Ink Cape': 'ผ้าคลุมน้ำหมึก',
  'Still a bit wet.': 'ยังเปียกอยู่นิดหน่อย',
  'Lucky Clover Sticker': 'สติกเกอร์โคลเวอร์นำโชค',
  'Smells like strawberries.': 'หอมกลิ่นสตรอว์เบอร์รี',
  'Gold Star': 'ดาวทอง',
  'Teacher said "Excellent!"': 'คุณครูบอกว่า "เยี่ยมมาก!"',
  'Paper Crown': 'มงกุฎกระดาษ',
  'From the birthday party.': 'ได้มาจากงานวันเกิด',
  'Stapler Gauntlet': 'ถุงมือแม็กเย็บกระดาษ',
  'Ka-chunk!': 'แกร๊ก!',
  'Neon Highlighter': 'ปากกาเน้นข้อความนีออน',
  'Glows in the dark. Never runs out.': 'เรืองแสงในที่มืด หมึกไม่มีวันหมด',
  'Glue Boots': 'รองเท้าบูตกาว',
  'You are not going anywhere.': 'ไม่ต้องไปไหนแล้วล่ะ',
  'Marker Cape': 'ผ้าคลุมปากกาเมจิก',
  'Permanent marker. Do not wash.': 'ปากกาเมจิกชนิดลบไม่ออก ห้ามซัก',
  'Rubber Band': 'หนังยาง',
  'Snap!': 'เป๊าะ!',
  'Hall Pass': 'บัตรผ่านทางเดิน',
  'Lets you go anywhere. Even the staff room.': 'ไปได้ทุกที่ แม้แต่ห้องพักครู',

  // Equipment slots
  weapon: 'อาวุธ',
  armor: 'ชุดเกราะ',
  charm: 'เครื่องราง',
  Weapon: 'อาวุธ',
  Armor: 'ชุดเกราะ',
  Charm: 'เครื่องราง',

  // Quests
  'First Recess Battle': 'ศึกแรกตอนพักเที่ยง',
  'Win your first battle.': 'ชนะการต่อสู้ครั้งแรก',
  'Back-of-the-Book Artist': 'ศิลปินท้ายสมุด',
  'Draw and save your own monster.': 'วาดและบันทึกมอนสเตอร์ของตัวเอง',
  'Rock Solid': 'ค้อนแกร่ง',
  'Win 5 rounds with Rock.': 'ออกค้อนชนะ 5 รอบ',
  'Paper Trail': 'เส้นทางกระดาษ',
  'Win 5 rounds with Paper.': 'ออกกระดาษชนะ 5 รอบ',
  'Snip Snip': 'ฉึบ ฉึบ',
  'Win 5 rounds with Scissors.': 'ออกกรรไกรชนะ 5 รอบ',
  'On a Roll': 'กำลังมา',
  'Reach a 3-round combo.': 'ทำคอมโบ 3 รอบติด',
  'Playground Veteran': 'ขาประจำสนามเด็กเล่น',
  'Fight 10 battles.': 'สู้ครบ 10 ครั้ง',
  'Monster Hunter': 'นักล่ามอนสเตอร์',
  'Defeat 6 different monsters in the back of the book.': 'ชนะมอนสเตอร์ท้ายสมุด 6 ตัวที่ไม่ซ้ำกัน',
  'Show and Tell': 'โชว์ของ',
  'Share a monster with a friend.': 'แชร์มอนสเตอร์ให้เพื่อน',
  'Classroom Rival': 'คู่ปรับในห้องเรียน',
  'Battle a friend online.': 'สู้กับเพื่อนออนไลน์',
  'Growing Up': 'โตขึ้นแล้ว',
  'Reach level 5.': 'เลเวลถึง 5',
  'Past the Last Page': 'เลยหน้าสุดท้าย',
  'Defeat every monster in the book, back cover included.': 'ชนะมอนสเตอร์ทุกตัวในสมุด รวมถึงที่ปกหลังด้วย',
  'Top of the Class': 'ที่หนึ่งของห้อง',
  'Reach level 10.': 'เลเวลถึง 10',
  Unstoppable: 'หยุดไม่อยู่',
  'Reach a 5-round combo.': 'ทำคอมโบ 5 รอบติด',
  'Recess Legend': 'ตำนานช่วงพัก',
  'Fight 25 battles.': 'สู้ครบ 25 ครั้ง',
  'Rock Star': 'ร็อกสตาร์',
  'Win 20 rounds with Rock.': 'ออกค้อนชนะ 20 รอบ',

  // Story chapters (Quest Pages)
  Prologue: 'บทนำ',
  'A New Journey': 'การเดินทางครั้งใหม่',
  'Something is scribbling in the margins of your notebook. Grab a pencil and find out what.': 'มีอะไรบางอย่างขีดเขียนอยู่ที่ขอบสมุดของคุณ หยิบดินสอแล้วไปดูกันว่าคืออะไร',
  'The Whispering Forest': 'ป่ากระซิบ',
  'Chapter 2': 'บทที่ 2',
  'The doodled trees whisper about an eraser beast and a dragon drawn on the last page.': 'ต้นไม้ที่ถูกวาดไว้กระซิบกันถึงสัตว์ประหลาดยางลบ และมังกรที่ถูกวาดไว้หน้าสุดท้าย',
  'The Lost Bridge': 'สะพานที่หายไป',
  'Chapter 3': 'บทที่ 3',
  'Someone stapled and glued the bridge to the back cover shut. Unstick it!': 'ใครบางคนเย็บแม็กแล้วทากาวปิดสะพานไปปกหลังจนติดแน่น ไปแกะมันออกมา!',
  "The Principal's Office": 'ห้องครูใหญ่',
  'Final Chapter': 'บทสุดท้าย',
  'A neon glow leaks from under the office door. The final page awaits.': 'แสงนีออนเล็ดลอดออกมาจากใต้ประตูห้อง หน้าสุดท้ายกำลังรออยู่',
  'Chapter complete: {chapter}': 'จบบทแล้ว: {chapter}',
  'The page is filled in! +{coins} coins.': 'เติมหน้านี้ครบแล้ว! +{coins} เหรียญ',

  // Moves
  Rock: 'ค้อน',
  Paper: 'กระดาษ',
  Scissors: 'กรรไกร',
};
